import Stack from 'src/app/atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const ImageContainer = styled(Stack)`
  height: 100%;
`;
